export default "__VITE_ASSET__C_wNwDiZ__ 480w, __VITE_ASSET__Bh6Twk0K__ 768w, __VITE_ASSET__D$bSSHUC__ 1200w, __VITE_ASSET__DnhCvLLI__ 1280w";